import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemUrlSelector =
  (bomItemId: string) => (state: RootAppState) => {
    if (window.self !== window.top) {
      // no support for referrals url in iframe
      return null
    }

    if (bomItemId === state.project.activeProject?.id) {
      return `${window.location}/${state.project.activeProject.id}`
    }

    const bomItem = bomItemSelector(state, bomItemId)

    return `${window.location.origin}/app/project/${state.project.activeProject.id}/bomitem/${bomItem?.id}`
  }
